import React, { Fragment, useEffect, useState } from "react";
import "semantic-ui-css/semantic.min.css";
import { useLocation } from "react-router-dom";
import { sidebarStaticData } from "./sidebarStaticData";
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import UnivercityDashboard from '../../assets/upgrade-images/university_admin_dashboard.svg'

export default function SidebarComponent() {
    const location = useLocation()
    const dispatch = useDispatch();
    const [activeItem, setActiveItem] = useState(location.pathname)
    const isToggle = useSelector(state => state.componentReducer.isToggle)
    // const [isToggle, setIsToggle] = useState(true);
    const profileDetail = useSelector(state => (state.profileReducer.profileDetail));
    let userRole = profileDetail?.data?.user?.role

    useEffect(() => {
        setActiveItem(location.pathname)
    }, [location?.pathname])
    
    const sidebarNavs = [
  ...(sidebarStaticData?.[userRole] || []),
  ...(sidebarStaticData?.contactus || []),
];


    return (
     <>
      {/* MOBILE OVERLAY */}
      {!isToggle && (
        <div
          onClick={() =>
            dispatch({
              type: "SET_SIDEBAR_TOGGLE",
              payload: true,
            })
          }
    className="fixed inset-0 bg-black/40 z-40 md:hidden"        />
      )}

      <div className="bg-[#0054A6] h-full w-full md:w-[18.4375rem]">
          <aside
            className={`fixed md:static top-[64px] md:top-0 left-0 z-50 h-[calc(100vh-64px)] md:h-full w-[18.4375rem] bg-[#0054A6] transition-transform duration-300 ease-in-out ${isToggle ? "-translate-x-full" : "translate-x-0"} md:translate-x-0 px-4`}
          >
          <Sidebar
            navs={sidebarNavs}
            activeItem={activeItem}
            activeSubTab={location?.state?.subNav || ""}
            isToggle={isToggle}
          />
        </aside>
      </div>
    </>

    );
}


const Sidebar = ({ navs, activeItem, isToggle, className = 'py-8', activeSubTab='' }) => {
    return (
        <>
        <ul className={`overflow-y-auto scrollbar space-y-3 ${isToggle ? 'h-[calc(100%-10rem)]' : 'h-[calc(100%-15rem)] md:h-full'} ${className}`}>
            {navs?.map(({ manuName, listName, path, iconName, iconImage, iconClassName, subNavs }) => (
                <Fragment key={`aside-tabs-${manuName}-${listName}`}>
                    <li className={`relative rounded-md transition-all duration-300
                  ${activeItem === path ||  activeItem.startsWith(`${path}/`)? "bg-gradient-to-r from-[#075BA6] to-[#5BB6A8]" : ""}`}>
                        <span className={`py-2 block relative`}>
                            {(activeItem === path ||  activeItem.startsWith(`${path}/`)) && 
                             <span className="absolute left-0 top-0 bottom-0 w-2 bg-white rounded-l-md"></span>
                            }
                            <Link
                                to={path}
                                className={`flex items-center sm:items-start justify-start gap-6 relative text-lg h-full py-1 pl-6 ${(activeSubTab === path) ? 'bg-[#000000] dark:bg-[#B1B1B133]' : ''} ${activeItem === path ||  activeItem.startsWith(`${path}/`) ? 'border-[#2076bc] dark:border-gray-400' : ''}`}
                            >
                                <div className={`flex items-start h-full w-full  ${isToggle ? 'justify-start ps-2' : 'justify-start px-2 md:px-0 md:justify-center'}`}>
                                        {iconName ? (
                                            <i className={`!m-0 dark:invert dark:grayscale ${iconName}`}></i>
                                        ) : iconImage ? (
                                            <img
                                                className={`dark:invert dark:grayscale ${iconClassName || ''}`}
                                                src={iconImage}
                                                alt={listName}
                                                loading="lazy"
                                            />
                                        ) : ''}
                                    <span className={`font-rubik text-[#FFFFFF] font-semibold text-[14px] dark:text-[#FFFFFF] px-2 whitespace-nowrap ${isToggle ? '' : 'block md:hidden'}`}>
                                        {listName}
                                    </span>
                                </div>
                            </Link>
                        </span>
                        {subNavs && (
                            <Sidebar navs={subNavs} activeItem={activeItem} isToggle={isToggle} className="pl-4"  activeSubTab={activeSubTab}/>
                        )
                        }
                    </li>
                </Fragment>
            ))}
        </ul>
    </>
    );
};

